"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var idm_application_properties_service_client_js_1 = require("@synisys/idm-application-properties-service-client-js");
var idm_common_util_frontend_1 = require("@synisys/idm-common-util-frontend");
var idm_authentication_client_js_1 = require("@synisys/idm-authentication-client-js");
var recommendation_service_1 = require("./recommendation-service");
var idm_message_language_service_client_js_1 = require("@synisys/idm-message-language-service-client-js");
require("rxjs/add/observable/zip");
var dataset_container_1 = require("../sis-tabular-report-designer/service/dataset-container");
var Observable_1 = require("rxjs/Observable");
var operators_1 = require("rxjs/operators");
var HttpRecommendationService = /** @class */ (function (_super) {
    __extends(HttpRecommendationService, _super);
    function HttpRecommendationService(http, applicationPropertiesService, messageService, languageService, datasetContainer) {
        var _this = _super.call(this) || this;
        _this.http = http;
        _this.applicationPropertiesService = applicationPropertiesService;
        _this.messageService = messageService;
        _this.languageService = languageService;
        _this.datasetContainer = datasetContainer;
        return _this;
    }
    HttpRecommendationService_1 = HttpRecommendationService;
    HttpRecommendationService.prototype.predictRow = function (datasetId, rows, columns) {
        var _this = this;
        return Observable_1.Observable.fromPromise(this.applicationPropertiesService.getProperty(HttpRecommendationService_1.REPORT_RECOMMENDATION_SERVICE_NAME))
            .pipe(operators_1.switchMap(function (url) {
            if (url) {
                return _this.http.get(HttpRecommendationService_1.REPORT_ROW_RECOMMENDATION_PATH
                    .replaceTemplate({ serviceUri: url, datasetId: datasetId.toString(), columns: columns === '' ? ',' : columns, rows: rows === '' ? ',' : rows }))
                    .flatMap(function (data) {
                    return _this.constructPathPredictions(datasetId, data.row_suggestions);
                });
            }
            else {
                console.warn('Recommendation service url is not present!');
                return Observable_1.Observable.of(new Map());
            }
        }), operators_1.catchError(function (err) {
            console.warn(err);
            return Observable_1.Observable.of(new Map());
        }));
    };
    HttpRecommendationService.prototype.predictColumn = function (datasetId, rows, columns) {
        var _this = this;
        return Observable_1.Observable.fromPromise(this.applicationPropertiesService.getProperty(HttpRecommendationService_1.REPORT_RECOMMENDATION_SERVICE_NAME))
            .pipe(operators_1.switchMap(function (url) {
            if (url) {
                return _this.http.get(HttpRecommendationService_1.REPORT_COLUMN_RECOMMENDATION_PATH
                    .replaceTemplate({ serviceUri: url, datasetId: datasetId.toString(), columns: columns === '' ? ',' : columns, rows: rows === '' ? ',' : rows }))
                    .flatMap(function (data) {
                    return _this.constructPathPredictions(datasetId, data.column_suggestions);
                });
            }
            else {
                console.warn('Recommendation service url is not present!');
                return Observable_1.Observable.of(new Map());
            }
        }), operators_1.catchError(function (err) {
            console.warn(err);
            return Observable_1.Observable.of(new Map());
        }));
    };
    HttpRecommendationService.prototype.constructPathPredictions = function (datasetId, suggestions) {
        return this.datasetContainer.getAllPaths(datasetId).map(function (paths) {
            return suggestions.reduce(function (predictionCoefficient, suggestion) {
                return predictionCoefficient.set(paths.get(+suggestion.id), suggestion.prediction);
            }, new Map());
        });
    };
    var HttpRecommendationService_1;
    HttpRecommendationService.REPORT_RECOMMENDATION_SERVICE_NAME = 'report-structure-recommendation-service-url';
    HttpRecommendationService.REPORT_ROW_RECOMMENDATION_PATH = idm_common_util_frontend_1.StringTemplate
        .createTemplate(templateObject_1 || (templateObject_1 = __makeTemplateObject(["", "/dataset/", "/recommend_row?col_pattern=", "&row_pattern=", ""], ["", "/dataset/", "/recommend_row?col_pattern=", "&row_pattern=", ""])), 'serviceUri', 'datasetId', 'columns', 'rows');
    HttpRecommendationService.REPORT_COLUMN_RECOMMENDATION_PATH = idm_common_util_frontend_1.StringTemplate
        .createTemplate(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", "/dataset/", "/recommend_column?col_pattern=", "&row_pattern=", ""], ["", "/dataset/", "/recommend_column?col_pattern=", "&row_pattern=", ""])), 'serviceUri', 'datasetId', 'columns', 'rows');
    HttpRecommendationService = HttpRecommendationService_1 = __decorate([
        core_1.Injectable(),
        __metadata("design:paramtypes", [idm_authentication_client_js_1.HttpClientWrapper, idm_application_properties_service_client_js_1.ApplicationPropertiesService,
            idm_message_language_service_client_js_1.MessageService, idm_message_language_service_client_js_1.LanguageService,
            dataset_container_1.DatasetContainer])
    ], HttpRecommendationService);
    return HttpRecommendationService;
}(recommendation_service_1.RecommendationService));
exports.HttpRecommendationService = HttpRecommendationService;
var templateObject_1, templateObject_2;
//# sourceMappingURL=http-recommendation-service.js.map